import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03d53d5b")

_pushScopeId("data-v-03d53d5b")
const _hoisted_1 = { class: "p-grid p-m-2 table-list-container" }
const _hoisted_2 = { class: "p-col-6 p-d-flex p-flex-column" }
const _hoisted_3 = { class: "kn-list-item-text" }
const _hoisted_4 = { class: "p-col-6 p-d-flex p-flex-column" }
const _hoisted_5 = { class: "kn-list-item-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.availableTables')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Listbox, {
        class: "kn-list link-list kn-flex",
        listStyle: _ctx.linkTabDescriptor.style.listbox,
        options: _ctx.availableTables,
        filter: true,
        filterPlaceholder: _ctx.$t('common.search'),
        optionLabel: "name",
        filterMatchMode: "contains",
        filterFields: _ctx.linkTabDescriptor.filterFields,
        emptyFilterMessage: _ctx.$t('common.info.noDataFound')
      }, {
        option: _withId((slotProps) => [
          _createVNode("div", {
            class: "kn-list-item",
            onClick: ($event: any) => (_ctx.addTableToSelectedList(slotProps.option))
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
            ])
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["listStyle", "options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.selectedTables')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Listbox, {
        class: "kn-list link-list kn-flex",
        listStyle: _ctx.linkTabDescriptor.style.listbox,
        options: _ctx.selectedTables,
        filter: true,
        filterPlaceholder: _ctx.$t('common.search'),
        optionLabel: "name",
        filterMatchMode: "contains",
        filterFields: _ctx.linkTabDescriptor.filterFields,
        emptyFilterMessage: _ctx.$t('managers.datasetManagement.noLinkedTables')
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        option: _withId((slotProps) => [
          _createVNode("div", {
            class: "kn-list-item",
            onClick: ($event: any) => (_ctx.removeTableFromSelectedList(slotProps.option))
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
            ])
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["listStyle", "options", "filterPlaceholder", "filterFields", "emptyFilterMessage"])
    ])
  ]))
})